import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramCriticalAnalysis/programCriticalAnalysis.module.scss';
import TextSearchInput from 'components/common/TextSearchInput/textSearchInput';
import { MyCustomSelect } from 'components/common';
import { InputOption, ValueContainer } from 'components/common/MyCustomSelect/myCustomSelect';
import React, { useState } from 'react';
import { morefilterItems } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramCriticalAnalysis/utils';
import SwitchComponent from 'components/common/Switch/Switch';
export const statusOptions: ISelectOption<string>[] = [
    {
        value: 'TODO',
        label: 'To Do',
    },
    {
        value: 'IN_PROGRESS',
        label: 'In Progress',
    },
    {
        value: 'Done',
        label: 'Done',
    },
];

export const CriticalAnalysisDelayDriversFilter = ({
    handleOnSearch,
    dateFilter,
    handleDateFilter,
    months,
    handleStatusType,
    statusFilter,
    handleStatus,
    typeFilter,
    handleCriticalPath,
    isCriticalPath,
    handleDelayDriver,
    isDelayDriver,
}) => {
    const [searchText, setSearchText] = useState('');

    const handleSearchFilterSubmitted = () => {
        handleOnSearch(searchText);
    };

    const handleClear = () => {
        setSearchText('');
        handleOnSearch('');
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            handleOnSearch(searchText);
        }
    };

    return (
        <div className={classes.filterWrapper}>
            <div className={classes.title}>Name</div>
            <div className={classes.filterTextSearch}>
                <TextSearchInput
                    placeholder="Search Activities by Name"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    handleClear={handleClear}
                    maxLength={200}
                    handleClick={handleSearchFilterSubmitted}
                    onKeyDown={onKeyDown}
                    className={classes.textInput}
                />
            </div>

            <div className={classes.selectWrapper}>
                <div className={classes.title}>Month</div>
                <MyCustomSelect<ISelectOption<string>>
                    value={dateFilter}
                    options={months}
                    onChange={handleDateFilter}
                />
            </div>
            <div className={classes.selectWrapper}>
                <div className={classes.title}>Status</div>
                <MyCustomSelect<ISelectOption<string>, true>
                    id={'status-filter'}
                    value={statusFilter}
                    options={statusOptions}
                    onChange={handleStatusType}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select Status...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>
            <div>
                Delay Driver
                <SwitchComponent onChange={handleDelayDriver} checked={isDelayDriver} />
            </div>
            <div>
                Critical Path Only
                <SwitchComponent onChange={handleCriticalPath} checked={isCriticalPath} />
            </div>
            <div className={classes.selectWrapper}>
                <div className={classes.title}>More Filters</div>
                <MyCustomSelect<ISelectOption<string>, true>
                    value={typeFilter}
                    options={morefilterItems}
                    onChange={handleStatus}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select More Filters...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>
        </div>
    );
};
